import styled from '@emotion/styled'

import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'

import { theme } from '../../themes/theme'
import { FlexColumn, FlexRow } from './Containers'
import { TableHeaderButton } from '../common/Button'
import BodyText from './Text'

// SHARED CONDENSED TABLE STYLING

export const CondensedTable = styled(FlexColumn)`
  gap: 0;
`

export const HeaderRow = styled(FlexRow)`
  padding: 5px 20px;
  gap: 30px;
  align-items: center;
`

export const ContentRow = styled(HeaderRow)`
  cursor: pointer;

  :hover {
    background: ${theme.colors.primaryExtraLight};
  }
`

export const HeaderButton = styled(TableHeaderButton)`
  font-size: 16px;
  font-weight: 400;
`

export const EmptyText = styled(BodyText)`
  display: flex;
  justify-content: center;
  padding: 15px 20px;
`

export const UnfoldMoreIconRight = styled(UnfoldMoreIcon)`
  margin-right: -7px;
`

// TEMPLATE TABLE SPECIFIC

export const TemplateNameColumn = styled.div`
  flex-basis: 70%;
`

export const TemplateDateColumn = styled(FlexRow)`
  flex-basis: 30%;
  justify-content: flex-end;
  gap: 5px;
  flex-wrap: wrap;
  word-break: break-word;
`

export const TemplateActionContainer = styled(FlexRow)`
  width: 29px;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
`
